export enum TelephoneTypeLieuEnum {
  RESIDENCE_PRINCIPALE = 'RESIDENCE_PRINCIPALE',
  LIEU_TRAVAIL = 'LIEU_TRAVAIL',
  AUTRE = 'AUTRE',
}
